export default {
  INVALID_ID: 'ID must be a 9 digit number',
  LETTERS_ONLY: 'Name can only contain letters',
  USERNAME_CHARACTERS: 'Name can only contain alpha-numeric characters or underscore (_), and must begin with a letter or an underscore',
  USERNAME_LENGTH: 'Username must be 8 to 24 characters long',
  USERNAME_EXISTS: 'Username already exists',
  EMAIL_EXISTS: 'E-mail already exists',
  NPI_EXISTS: 'NPI already exists',
  PASSWORD_CHARACTERS: 'Password cannot contain characters other than alpha-numeric characters and , . ? ~ ! @ # $ % ^ & * _',
  PASSWORD_LENGTH: 'Password must be 12 to 24 characters long',
  PASSWORD_MISMATCH: 'Passwords must match',
  NO_SPECIAL_CHARACTERS: 'Cannot contain special characters',
  NO_SPECIAL_CHARACTERS_OR_NUMBERS: 'Cannot contain special characters or numbers',
  INVALID_PHONE_NUMBER: 'Invalid phone number',
  INVALID_DEVICE_ID: 'Device ID must be exactly 16 characters',
  INVALID_SSN: 'Only last 4 digits of SSN',
};